import { render, staticRenderFns } from "./lv2.vue?vue&type=template&id=4d57c57a&scoped=true&"
import script from "./lv2.vue?vue&type=script&lang=js&"
export * from "./lv2.vue?vue&type=script&lang=js&"
import style0 from "./lv2.vue?vue&type=style&index=0&id=4d57c57a&scoped=true&lang=css&"
import style1 from "./lv2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57c57a",
  null
  
)

export default component.exports